
angular.module('theme.core.filters')

.filter('replace', function () {
  return function (input, from, to) {
    if(input === undefined) {
      return;
    }
    var regex = new RegExp(from, 'g');
    return input.replace(regex, to);
  };
})
